import { MenuItem } from "@mui/material";
import { Participant } from "../../interfaces/interfaces";
import axios from "axios";
import { useSnackbar } from "notistack";
import React from "react";

import { SearchParticipantContext } from "../../context/searchParticipantContext";
import { User, AppContext } from "../../../../context/appContext";
import { endpoints } from "../../../../endpoints/endpoints";

const ReleaseCoachBinding = ({
  participant,
  handleClose,
}: {
  participant: Participant;
  handleClose: (event: React.MouseEvent<HTMLElement> | null) => void;
}): React.JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    startSearch,
  }: {
    startSearch: () => void;
  } = React.useContext(SearchParticipantContext);

  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const [doubleCheck, setDoubleCheck] = React.useState(false);

  const isInactive = participant.status === 1;
  const hasNoAppointment = participant.appointments.meta.total === 0;
  const isDisabled =
    isInactive || hasNoAppointment || participant.coachBindingReleased;

  const handleClick = (): void => {
    if (!doubleCheck) {
      setDoubleCheck(true);
      return;
    }

    releaseCoachBindingRequest();
    setDoubleCheck(false);
    handleClose(null);
  };

  const buildSuccessMessage = (cancelledAppointments: number): string => {
    if (cancelledAppointments === 0) return "Coachbindung aufgehoben";
    if (cancelledAppointments === 1)
      return "Coachbindung aufgehoben, 1 Termin storniert";
    return `Coachbindung aufgehoben, ${cancelledAppointments} Termine storniert`;
  };

  const releaseCoachBindingRequest = async (): Promise<void> => {
    await axios
      .post(endpoints.admin.releaseCoachBinding, {
        sessionId: user.sessionId,
        participantId: participant.participantId,
      })
      .then(async (response) => {
        checkSession(response);

        if (response.data.meta?.status === "success") {
          enqueueSnackbar(
            buildSuccessMessage(response.data.data?.cancelledAppointments ?? 0),
            { variant: "success" },
          );
          startSearch();
        } else {
          enqueueSnackbar(
            response.data.meta?.message ?? "Fehler beim Aufheben der Coachbindung",
            { variant: "error" },
          );
        }
      })
      .catch((error) => {
        console.error("Error releasing coach binding", error);
      });
  };

  const getMenuItemText = (): string => {
    if (doubleCheck) return "Sind Sie sicher?";
    if (participant.coachBindingReleased)
      return "Coachbindung bereits aufgehoben";
    return "Coachbindung aufheben";
  };

  return (
    <MenuItem
      disabled={isDisabled}
      onClick={handleClick}
      sx={{
        wordBreak: "all",
      }}
    >
      {getMenuItemText()}
    </MenuItem>
  );
};

export default ReleaseCoachBinding;
